import { Component, inject } from '@angular/core';
import { UntypedFormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import {IRib} from '../../shared/model/rib.model';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatFormField, MatLabel, MatHint, MatError } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-add-rib-dialog',
    templateUrl: 'iban-add-dialog.html',
    styleUrls: ['./iban-add-dialog.css'],
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatFormField, MatLabel, MatInput, FormsModule, ReactiveFormsModule, MatHint, MatError, MatDialogActions, MatButton, MatDialogClose]
})
export class IbanAddDialogComponent {
  dialogRef = inject<MatDialogRef<IbanAddDialogComponent>>(MatDialogRef);
  data = inject<IRib>(MAT_DIALOG_DATA);


  iban: UntypedFormControl = new UntypedFormControl('', [Validators.required, Validators.pattern(String.raw`^[A-Z]{2}\d{2}[A-Z0-9]{10,30}$`)]);

  onNoClick(): void {
    this.dialogRef.close();
  }

  getErrorIban(): string {
    if (this.iban.hasError('required')) {
      return 'Un IBAN est requis';
    }

    if (this.iban.hasError('pattern')) {
      return 'L\'iban n\'est pas valide';
    }

    return '';
  }
}
